import React from "react"
import { Card, CardBody } from "reactstrap"
import SectionHeader from "./SectionHeader"
const CardLayout = ({ icon, title, action, children }) => {
  return (
    <Card className="border-0 shadow-sm h-100">
      <CardBody className="p-3">
        <SectionHeader icon={icon} title={title} action={action} />
        {children}
      </CardBody>
    </Card>
  )
}

export default CardLayout
